<style>
.userinfo {
	line-height: 0.9;
}
</style>
<template>
	<v-app id="inspire">
		<v-app-bar app clipped-right flat dense color="white" elevation="1">
			<v-app-bar-nav-icon @click.stop="primaryDrawer = !primaryDrawer"></v-app-bar-nav-icon>
			<v-toolbar-title class="font-weight-medium" v-if="$vuetify.breakpoint.smAndUp">{{ toolbartitle }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-avatar tile v-if="$appOptions.tenantLogo()" class="mr-2 pa-1">
				<v-img :src="$appOptions.tenantLogo()" contain alt="Logo"></v-img>
			</v-avatar>
			<div v-if="user.name" class="userinfo">
				<span class="font-weight-medium" v-if="user.tenant.shortname && !$vuetify.breakpoint.xsOnly">{{ user.tenant.shortname }}</span>
				<br v-if="user.tenant.shortname && !$vuetify.breakpoint.xsOnly" />
				<span class="text-caption">{{ user.name }} {{ user.surname }}</span>
			</div>
			<v-menu bottom left offset-y origin="top right" transition="scale-transition" v-model="userMenu">
				<template v-slot:activator="{ attrs, on }">
					<v-btn class="ml-2" min-width="0" fab small depressed v-bind="attrs" @click="userMenu = !userMenu">
						<v-icon>fas fa-caret-down</v-icon>
					</v-btn>
				</template>
				<v-list tile nav dense v-if="userMenu">
					<v-list-item>
						<v-list-item-avatar>
							<v-img :src="$appOptions.tenantLogo()" contain alt="Logo"></v-img>
						</v-list-item-avatar>
						<v-list-item-content v-if="user.name">
							<v-list-item-title>{{ user.name }} {{ user.surname }}</v-list-item-title>
							<v-list-item-subtitle>{{ user.tenant.shortname }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<template v-for="(item, i) in userMenuItems">
						<base-item-group v-if="item.children" :key="`group-${i}`" :item="item"></base-item-group>
						<base-item v-else :key="`item-${i}`" :item="item"></base-item>
					</template>
					<v-list-item dense link @click="logout()">
						<v-list-item-icon>
							<v-icon>fas fa-sign-out-alt</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>Logout</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
		<v-navigation-drawer v-model="primaryDrawer" fixed app dense id="main-navigation-drawer">
			<v-img :src="$appOptions.systemLogo()" contain @click="$router.push({ name: 'dashboard' })" class="clickarea">
				<template v-slot:placeholder>
					<v-sheet>
						<v-skeleton-loader type="image"></v-skeleton-loader>
					</v-sheet>
				</template>
			</v-img>
			<v-divider class="mb-2"></v-divider>
			<v-list expand nav dense>
				<template v-for="(item, i) in drawerItems">
					<base-item-group v-if="item.children" :key="`group-${i}`" :item="item"></base-item-group>
					<base-item v-else :key="`item-${i}`" :item="item"></base-item>
				</template>
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<v-banner app single-line v-model="showOnlineBanner" dark :color="isOffline ? 'blue' : 'success'" rounded transition="slide-y-transition">{{ isOffline ? "Connessione internet assente" : "Di nuovo online!" }}</v-banner>
			<server-down v-if="serverdown"></server-down>
			<router-view v-else-if="user.tenant" class="pb-10"></router-view>
			<v-row dense align="center" justify="center" style="height: 100%" v-else>
				<v-progress-circular indeterminate width="2"></v-progress-circular>
			</v-row>
			<material-dialog></material-dialog>
		</v-main>
		<v-footer app>
			<span class="pr-3">
				<v-avatar size="24">
					<v-img :src="$appOptions.systemLogoQuadrato()">
						<template v-slot:placeholder>
							<v-sheet>
								<v-skeleton-loader type="image"></v-skeleton-loader>
							</v-sheet>
						</template>
					</v-img>
				</v-avatar>
			</span>

			<span>{{ "Studio LGA" }} &copy; {{ new Date().getFullYear() }}</span>
			<v-spacer></v-spacer>
			<span class="caption" v-text="appVersion"></span>
		</v-footer>
		<!-- snackbar -->
		<v-snackbar :timeout="snackbarDuration" :color="snackbarColor" top v-model="showSnackbar">
			{{ snackbarMessage }}
		</v-snackbar>
		<systemmessages-toread></systemmessages-toread>
		<attachments v-if="showAttachment"></attachments>
		<attachment-list popup v-if="showAttachmentList"></attachment-list>
	</v-app>
</template>

<script>
import i18n from "../modules/i18n";

export default {
	data: () => ({
		rightdrawer: false,
		userMenu: false,
		showOnlineBanner: false,
		rerender: 0,
		impersonificating_stopping: false,
	}),
	props: ["appversion"],
	computed: {
		appVersion() {
			return this.$store.getters.getAppVersion;
		},
		showAttachment() {
			return this.$store.getters.showAttachment;
		},
		showAttachmentList() {
			return this.$store.getters.showAttachmentList;
		},
		isOffline() {
			return this.$store.getters.isOffline;
		},
		primaryDrawer: {
			get() {
				return this.$store.getters.getPrimaryDrawer;
			},
			set(val) {
				if (val != this.$store.getters.getPrimaryDrawer) {
					this.$store.commit("setPrimaryDrawer", val);
				}
			},
		},
		mainRoutes() {
			let routes = [];
			routes.push({
				icon: "fas fa-computer",
				title: this.$t("title.simulator"),
				to: "/",
			});

			if (this.$hasRole("admin")) {
				routes.push({
					icon: "far fa-id-card",
					title: this.$t("title.clients"),
					to: "/admin/clients",
				});
				routes.push({
					icon: "fas fa-user",
					title: this.$t("title.users"),
					to: "/admin/users",
				});
				routes.push({
					icon: "fas fa-receipt",
					title: this.$t("title.invoices"),
					to: "/admin/invoices",
				});
				routes.push({
					icon: "fas fa-book",
					title: this.$t("title.incomedeclarations"),
					to: "/admin/incomedeclarations",
				});
				routes.push({
					icon: "fas fa-gears",
					title: this.$t("title.yeardata"),
					to: "/admin/yeardata",
				});
			} else {
				routes.push({
					icon: "fas fa-receipt",
					title: this.$t("title.invoices"),
					to: "/invoices",
				});
				routes.push({
					icon: "fas fa-book",
					title: this.$t("title.incomedeclarations"),
					to: "/incomedeclarations",
				});
			}
			return routes;
		},
		usermenuRoutes() {
			let routes = [];
			if (this.$hasRole("owner")) {
				routes.push({
					icon: "fas fa-laptop-house",
					title: this.$t("title.tenant"),
					to: "/tenant",
				});
			}
			if (this.$hasRole("owner") || this.$hasRole("admin")) {
				routes.push({
					icon: "fas fa-sliders-h",
					title: this.$t("title.options"),
					to: "/options",
				});
			}
			routes.push({
				icon: "fas fa-info-circle",
				title: this.$t("title.systemmessages"),
				to: "/system-messages",
			});
			routes.push({
				icon: "fas fa-unlock-alt",
				title: this.$t("title.changepassword"),
				to: "/changepassword",
			});
			return routes;
		},
		drawerItems() {
			return this.mainRoutes.map(this.mapItem);
		},
		userMenuItems() {
			return this.usermenuRoutes.map(this.mapItem);
		},
		toolbartitle() {
			let title = "";
			const self = this;
			if (this.$route) {
				let finded = this.mainRoutes.find((obj) => obj.to == self.$route.path);
				if (finded) {
					title = finded.title;
				}
			}
			return title;
		},
		//serverdown
		serverdown() {
			return this.$store.getters.serverdownmessage != null;
		},
		user() {
			return this.$store.getters.getUser;
		},
		//snackbar
		showSnackbar: {
			get() {
				return this.$store.getters.showSnackbar;
			},
			set(val) {
				if (!val) this.$store.commit("hideSnackbar");
			},
		},
		snackbarMessage() {
			return this.$store.getters.snackbarMessage;
		},
		snackbarColor() {
			return this.$store.getters.snackbarColor;
		},
		snackbarDuration() {
			return this.$store.getters.snackbarDuration;
		},
		// dialog
		showDialog: {
			get() {
				return this.$store.getters.showDialog;
			},
			set(val) {
				if (!val) this.$store.commit("hideDialog");
			},
		},
		tenantinfo() {
			return this.$store.getters.getTenantInfo;
		},
		lastClosedNotifications: {
			get() {
				return this.$store.getters.lastClosedNotifications;
			},
			set(val) {
				this.$store.commit("setLastClosedNotifications", val);
			},
		},
	},
	methods: {
		logout() {
			const self = this;
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("user.logout"),
				message: self.$t("user.logout_confirm_message"),
				okCb: () => {
					self.$store.dispatch("logout").then(() => {
						self.$router.push("/");
					});
				},
			});
		},
		mapItem(item) {
			return {
				...item,
				children: item.children ? item.children.map(this.mapItem) : undefined,
				title: item.title,
			};
		},
	},
	watch: {
		isOffline(val) {
			const self = this;
			if (val == true) {
				self.showOnlineBanner = true;
			} else {
				setTimeout(function () {
					self.showOnlineBanner = false;
				}, 1000);
			}
		},
	},
	beforeCreate() {
		if (this.$store.getters.isAuthenticated && _.isEmpty(this.$store.getters.getUser)) {
			this.$store.dispatch("fetchUser");
		}
	},
	created() {
		this.$store.commit("setAppVersion", this.appversion);
		this.$store.dispatch("fetchTenantInfo");
		document.title = "Simulatore Tassazione | Studio LGA";
	},
	mounted() {
		i18n.locale = "it";
		moment.locale("it");
		axios.defaults.headers.common["X-localization"] = "it";
		if ("ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
			this.$store.commit("setTouchState", true);
		}
		window.addEventListener("online", () => this.$store.commit("setOfflineState", false));
		window.addEventListener("offline", () => this.$store.commit("setOfflineState", true));
	},
};
</script>
